export const isHtmlRenderMode = sharedLink => {
  var _sharedLink$renderVie;
  return (sharedLink === null || sharedLink === void 0 || (_sharedLink$renderVie = sharedLink.renderView) === null || _sharedLink$renderVie === void 0 ? void 0 : _sharedLink$renderVie.renderMode) === 'HTML';
};
export const getHtmlRenderUrl = sharedLink => {
  var _sharedLink$renderVie2;
  return isHtmlRenderMode(sharedLink) ? sharedLink === null || sharedLink === void 0 || (_sharedLink$renderVie2 = sharedLink.renderView) === null || _sharedLink$renderVie2 === void 0 ? void 0 : _sharedLink$renderVie2.url : undefined;
};